import service from "@/service/request.js";
import { getCookieVal } from "../../tool/index";

//获取背景模板
export const getBaskgroundTemplate = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/getBaskgroundTemplate",
  method: "post",
  data
});

//添加背景绘制任务
export const addBackgroundTask = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/background",
  method: "post",
  data
});

//删除任务或者图片
export const removeTaskOrImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/removeTaskOrImage",
  method: "post",
  data
});

export const removePatternImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/task/detele",
  method: "post",
  data
})

//获取任务列表
export const getCommerceTasks = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/getCommerceTasks",
  method: "post",
  data
});

// 背景重绘----生成页调用
export const backgroundRedraw = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/background",
  method: "post",
  data
});

// 获取背景重绘人物详情
export const getCommerceTaskDetail = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/getCommerceTaskDetail",
  method: "post",
  data
});

// 工具集页面 无损放大
export const upscaleImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/upscaleImage",
  method: "post",
  data
});

export const superResolution = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/SuperResolution",
  method: "post",
  data
})

export const extractLayers = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/f_tools",
  method: "post",
  data
})
// 超分辨率（本地服务）
export const makeSuperResolution = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/api/super-resolution",
  method: "post",
  data
});

// 任务生成页面 无损放大
export const upscaleTaskImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/upscaleImage",
  method: "post",
  data
});

// 工具集页面 涂改编辑
export const eraseImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/erase",
  method: "post",
  data
});

// 任务生成页面 涂改编辑
export const eraseListImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/erase",
  method: "post",
  data
});

// 智能 抠图
export const GetImageSegment = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/GetImageSegment",
  method: "post",
  data
});

// 工具集 页面转3d
export const toolImageTo3D = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/ImageTo3D",
  method: "post",
  data
});

// 任务生成页 转3d
export const taskImageTo3D = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/ImageTo3D",
  method: "post",
  data
});

// 工具集 超级放大
export const toolSuperUpscale = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/SuperUpscale",
  method: "post",
  data
});

// 任务生成页 超级放大
export const taskSuperUpscale = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/SuperUpscale",
  method: "post",
  data
});

// 任务生成页 格式转换
export const convert = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/convert",
  method: "post",
  data
});

// 任务生成页 画质增强
export const EnhanceImage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/EnhanceImage",
  method: "post",
  data
});

// 工具集 智能扩图
export const outpainting = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/outpainting",
  method: "post",
  data
});

// 工具集 指令编辑
export const SeedEdit = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/SeedEdit",
  method: "post",
  data
});

//获取任务列表
export const getHotPatternsList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/iyw-ai-net/api/GenerateTask/GetList",
  method: "post",
  data
});


//融图
export const blend = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/blend",
  method: "post",
  data
});

//线稿
export const lineart = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/lineart",
  method: "post",
  data
});

// 线稿提取
export const lineExtraction = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/lineExtraction",
  method: "post",
  data
});

// 更换背景kontext版
export const imageModification = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/imageModification",
  method: "post",
  data
});

// 三视图功能
export const threeVisions = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/threeVisions",
  method: "post",
  data
});
//3d格式转换
export const convertThreeDesign = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/convertThreeDesign",
  method: "post",
  data
});

// 自由变款
export const productFission = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/fission",
  method: "post",
  data
});

// 工具名称 mix 融合图片 extract_pattern 提取图片 variation变款
export function g_tools(data) {
  return fetch(`${process.env.VUE_APP_API}/ai-application/api/commerce/g_tools`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      token: getCookieVal("iyuanwu_token"),
    }
  })
}

// 工具集收藏
export const addCommerceCollect = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/addCommerceCollect",
  method: "post",
  data
});

// 工具集取消收藏
export const removeCommerceCollect = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/removeCommerceCollect",
  method: "post",
  data
});

// 工具集取消收藏
export const getCollect = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/getCollect",
  method: "post",
  data
});

// 删除收藏图片
export const deleteCollectImg = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/deleteCollectImg",
  method: "post",
  data
});

// 配辅生款立即联系发送工单
export const sendProductMessage = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/userProduct/sendProductMessage",
  method: "post",
  data
});

// 优化提示词
export const promptRefine = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/prompt/refine",
  method: "post",
  data
});

// 提示词收藏列表
export const getPromptList = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/favourite/getPromptList",
  method: "post",
  data
});

// 取消提示词收藏
export const deletePrompt = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/favourite/deletePrompt",
  method: "post",
  data
});

// 收藏提示词
export const addPrompt = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-chat/api/favourite/addPrompt",
  method: "post",
  data
});

// 色号转换
export const extractColor = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/extractColor",
  method: "post",
  data
});

// 提取颜色保存历史记录
export const saveColor = data => service({
  baseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/commerce/saveColor",
  method: "post",
  data
});